import React from 'react';
import { Box, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';

import TruckIcon from '../../../../common/icons/truckIcon';
import CalendarIcon from '../../../../common/icons/calendarIcon';
import { formatEstimatedDeliveryDateMkp } from '../../../../../helpers/DateFormatter';
import { textInCapitalCase } from '../../../../../helpers/TextHelper';

import { market } from '../../../../../constants';

import { useExtraInfoStyles } from './styles';

const ExtraInfo = ({ ...props }) => {
  const { mobile, dispatch } = props;
  const classes = useExtraInfoStyles({ mobile });

  return (
    <Paper className={classes.container} elevation={0}>
      <Box className={classes.information}>
        <Box className={classes.detail}>
          <CalendarIcon size="25px" color="#464646" />
          <div className={`${classes.textSize}`}>
            <strong>Recibe: </strong>
            {dispatch?.type === 'mirakl' && market === 'cl'
              ? dispatch.estimated_delivery_date_text.replace('Recibe', '')
              : formatEstimatedDeliveryDateMkp(dispatch)}
          </div>
        </Box>
        {dispatch?.shipping_address?.street && (
          <Box className={classes.detail}>
            <TruckIcon size="25px" color="#464646" />
            <div className={`${classes.textSize}`}>
              <strong>Dirección de entrega: </strong>
              {textInCapitalCase(dispatch.shipping_address.street)},&nbsp;
              {textInCapitalCase(dispatch.shipping_address.province)},&nbsp;
              {textInCapitalCase(dispatch.shipping_address.region)}&nbsp;
            </div>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

ExtraInfo.propTypes = {
  mobile: PropTypes.bool,
  dispatch: PropTypes.object,
};

export default ExtraInfo;
